import React, { memo, useEffect, useState } from 'react';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface IProps {
  type?: 'type1' | 'type2' | 'type3' | 'type4' | undefined;
  value?: number | string | undefined;
  selectedValue?: number | string | undefined;
  text?: string;
  imgSrc?: string;
  rs?: string;
  className?: string;
  onClick?: () => void;
}

function Menu2LineBarItem({
  type = 'type1',
  value,
  selectedValue,
  text,
  imgSrc,
  rs,
  className,
  onClick,
}: IProps): React.JSX.Element {
  const [$value, setValue] = useState(String(value));
  const [$selectedValue, setSelectedValue] = useState(selectedValue);

  useEffect(() => {
    setValue(String(value));
    setSelectedValue(String(selectedValue));
  }, [selectedValue, value]);

  const cName = classNameBind([
    'menu2line-item item',
    $value === $selectedValue ? 'active' : '',
    className || '',
  ]);

  return (
    <S.Menu2LineBarItem className={cName} onClick={onClick} type={type}>
      {type === 'type1' && imgSrc && (
        <Img src={getResizeImageUrl(imgSrc, rs)} alt={String(value)} />
      )}
      <Text>{text}</Text>
    </S.Menu2LineBarItem>
  );
}

export default memo(Menu2LineBarItem);
